import React, { Component } from 'react';
import { Button, Popover, message } from 'antd';
import { CopyOutlined, ShareAltOutlined } from '@ant-design/icons';
import SvgIcon from '&/components/SvgIcon';
import dayjs from 'dayjs';
import QRCode from 'qrcode';
// import
import './index.scss';

export default class DesignBrief extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showQrcode: false,
        };
        this.qrcodeCanvas = React.createRef();
    }

    shareLink =
        window.location.protocol +
        '//' +
        window.location.host +
        `/decoration-design?projectId=${this.props.projectId}&div=2`;

    copyToClip = () => {
        const AUX = document.createElement('input');
        AUX.setAttribute('value', this.shareLink);
        document.body.appendChild(AUX);
        AUX.select();
        document.execCommand('copy');
        document.body.removeChild(AUX);
        message.success(intl.get('decorationDesign.copysuccessful'));
    };

    handlePopoverVisible = () => {
        if (this.state.showQrcode) return;
        setTimeout(() => {
            QRCode.toCanvas(
                this.qrcodeCanvas.current,
                this.shareLink,
                error => {
                    if (error) {
                        console.log(error);
                    } else {
                        this.setState({ showQrcode: true });
                    }
                }
            );
        });
    };
    render() {
        let { name, image, address, designName, updateDate } =
            this.props.detail || {};
        let briefImgStyle = {
            backgroundImage: `url(${image})`,
        };

        let itemInfo = [
            {
                label:
                    intl.get('decorationDesign.address') +
                    intl.get('decorationDesign.:'),
                value: address,
                icon: 'Icon-Design',
            },
            {
                label:
                    intl.get('decorationDesign.designer') +
                    intl.get('decorationDesign.:'),
                value: designName,
                icon: 'Icon-Design',
            },
            {
                label:
                    intl.get('decorationDesign.time') +
                    intl.get('decorationDesign.:'),
                value: dayjs.unix(updateDate).format('YYYY-MM-DD HH:mm'),
                icon: 'Icon-Clock',
            },
        ];

        const shareContent = () => (
            <div className="share-content">
                <div className="share-content-title">
                    {intl.get('decorationDesign.shareLink')}
                </div>
                <div className="share-link">
                    <div className="link-content">{this.shareLink}</div>
                    <Button type="primary" onClick={this.copyToClip}>
                        {intl.get('decorationDesign.copyLink')}
                    </Button>
                </div>
                <div className="share-content-title">
                    {intl.get('decorationDesign.qrCodeShare')}
                </div>
                <figure className="qr-code--share">
                    <canvas
                        className="qr-code-img"
                        width="160"
                        height="160"
                        id="qrcodeCanvas"
                        ref={this.qrcodeCanvas}></canvas>
                    <figcaption className="qr-code-name">
                        {intl.get('decorationDesign.weiChartScan')}
                    </figcaption>
                </figure>
            </div>
        );

        return (
            <div className="design-info">
                <div className="brief-img" style={briefImgStyle}></div>
                <div className="brief-info">
                    <span className="community-name">{name}</span>
                    <div>
                        {itemInfo.map((item, index) => {
                            return (
                                <div key={index} className="item-info">
                                    <SvgIcon iconName={item.icon}></SvgIcon>
                                    <label>{item.label}</label>
                                    <span>{item.value}</span>
                                </div>
                            );
                        })}
                    </div>
                    <div className="btn-row">
                        <Button onClick={this.copyToClip}>
                            {intl.get('decorationDesign.copyDesignLink')}
                        </Button>
                        <Popover
                            overlayClassName="share-popover"
                            placement="bottom"
                            title={null}
                            content={shareContent()}
                            trigger="click"
                            onVisibleChange={this.handlePopoverVisible}
                            arrowPointAtCenter>
                            <Button>
                                {intl.get('decorationDesign.share')}
                            </Button>
                        </Popover>
                        <Button>
                            {intl.get('decorationDesign.addToProject')}
                        </Button>
                    </div>
                    <div className="btn-row-mobile">
                        <Button
                            icon={<CopyOutlined />}
                            onClick={this.copyToClip}>
                            {intl.get('decorationDesign.copyDesignLink')}
                        </Button>
                        <Button icon={<ShareAltOutlined />}>
                            {intl.get('decorationDesign.share')}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
